import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ProductPage from './ProductPage';
import ProductTypesListPage from './ProductTypesList';
import ProductTypePage from './ProductTypePage';
import ProductByCategoryList from './ProductByCategoryList';
import ProductCatalog from './ProductCatalog';
import ProtectedRoute from '../../../router/Routes';
import { IAppState } from '../../../store/rootDuck';
import { ImportOffers } from './components/ImportOffers';
import { OffersList } from './components/OffersList';
import ProductCatalogCompany from './ProductCatalogCompany';
import { NavigateMyProductsCompany } from './ProductCatalogCompany/NavigateUser';
import ProductNewCatalog from './ProductNewCatalog';
import { ImportNewProducts } from './components/ImportNewProducts';
import { ImportProductData } from './components/ImportProductData';

export default function ProductsPage() {
  const { isAuthorized } = useSelector(({ auth }: IAppState) => ({
    isAuthorized: auth.user != null,
  }));

  return (
    <Routes>
      <Route
        path='create'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<ProductPage />} />}
      />
      <Route
        path='create/:parentId'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<ProductPage />} />}
      />
      <Route
        path='create/company/:companyIdProp/:companyNameProp?'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<ProductPage />} />}
      />
      <Route
        path='edit/:id'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<ProductPage />} />}
      />
      <Route path='list/:categoryId/:companyId?' element={<ProductByCategoryList />} />
      <Route
        path='types/list'
        element={
          <ProtectedRoute isAuthorized={isAuthorized} outlet={<ProductTypesListPage />} />
        }
      />
      <Route
        path='types/create'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<ProductTypePage />} />}
      />
      <Route
        path='types/edit/:typeId'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<ProductTypePage />} />}
      />
      <Route
        path='offer/import'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<ImportOffers />} />}
      />
      {/* <Route
        path='new/import'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<ImportNewProducts />} />}
      /> */}
      {/* <Route
        path='import_product_data'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<ImportProductData />} />}
      /> */}
      <Route
        path='offers/moderation'
        element={<ProtectedRoute isAuthorized={isAuthorized} outlet={<OffersList />} />}
      />
      <Route path='catalog/my_company' element={<NavigateMyProductsCompany />} />
      <Route path='catalog/company/:id' element={<ProductCatalogCompany />} />
      <Route path='catalog' element={<ProductCatalog />} />
      <Route path='catalog/categories' element={<ProductNewCatalog />} />
    </Routes>
  );
}
